import { __awaiter } from 'tslib';
import { im_proto } from '../../../proto/index.js';
import { InfoKeys, ErrorType, IMEvent } from '../../consts.js';
import { BaseError } from '../../errors/BaseError.js';
import { Logger } from '../../metrics/logger.js';
import { BaseProcessor } from './BaseProcessor.js';
import { ServiceIdentity } from '../RuntimeContext.js';

class UpdateExtProcessor extends BaseProcessor {
    process(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (item.data.type === im_proto.MessageType.MESSAGE_TYPE_UPDATE_MESSAGE_EXT) {
                item.needContinue = false;
                this.handleUpdateExt(item);
            }
            return item;
        });
    }
    handleUpdateExt(item) {
        var _a, _b, _c, _d;
        const serverId = (_a = item.data) === null || _a === void 0 ? void 0 : _a.ext[InfoKeys.ServerMessageId];
        if (!serverId) {
            throw new BaseError({
                ctx: this.ctx,
                type: ErrorType.InvalidServerId,
                msg: `message ${item.data} has no s:server_message_id`,
                sender: this
            });
        }
        const localMsg = this.resolve(ServiceIdentity.MessageManager).getByServerIdRaw((_b = item.conv) === null || _b === void 0 ? void 0 : _b.id, serverId);
        // 本地消息不存在则不处理
        if (!localMsg) {
            return;
        }
        // FIXME: version 可能有问题
        if (localMsg.version.gt(item.data.version)) {
            Logger.ctxWarn(this.ctx, `local msg version: ${localMsg.version.toString()} > online msg version: ${item.data.version.toString()}, ignore, local msg:`, localMsg, 'online msg:', item.data);
            return;
        }
        localMsg.ext = item.data.ext;
        localMsg.version = item.data.version;
        this.resolve(ServiceIdentity.MessageManager).upsert(localMsg);
        // FIXME: invisible --> visible not handled
        if (!localMsg.visible) {
            const allMessages = this.resolve(ServiceIdentity.MessageManager).getList(item.conv.id);
            for (const m of allMessages) {
                if (((_d = (_c = m.referenceInfo) === null || _c === void 0 ? void 0 : _c.referenced_message_id) === null || _d === void 0 ? void 0 : _d.toString()) === localMsg.serverId) {
                    m.referenceInfo.referenced_message_status = im_proto.MessageStatus.INVISIBLE;
                    this.resolve(ServiceIdentity.MessageManager).upsert(m);
                }
            }
        }
        this.resolve(ServiceIdentity.EventBus).emit(IMEvent.ReceiveNewUpdateExtMessage, this, item.data);
        if (item.data.ext[InfoKeys.IsRecalled] === 'true') {
            this.resolve(ServiceIdentity.MessageManager).markRecalled(item.conv.id, localMsg.serverId);
        }
    }
}

export { UpdateExtProcessor };
//# sourceMappingURL=UpdateExtProcessor.js.map
